export enum StoryType {
  PREVIEW = 'preview',
  WEB = 'web',
}
